import { render, staticRenderFns } from "./VisitorLeadSettingsTab.vue?vue&type=template&id=529e1d26"
import script from "./VisitorLeadSettingsTab.vue?vue&type=script&lang=js"
export * from "./VisitorLeadSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports